import React from 'react'
import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import Group from 'components/utils/Group'

export function RequestAgentCallbackErrorModal() {
  const intl = useIntl()
  return (
    <ModalBase>
      <form>
        <ModalHeader title={intl.formatMessage({
          id: 'Ux9N6YBMy6',
          defaultMessage: 'Callback request error',
          description: 'Title for callback request error modal',
        })}
        />
        <ModalBody>
          <ModalContent>
            <VerticalSpacer gap={20}>
              <Group direction="vertical" gap={20}>
                <BodyTextBlock variant="large">
                  {intl.formatMessage({
                    id: 'OJuF0JE1hx',
                    defaultMessage: 'There was an error scheduling your callback.',
                    description: 'Error message when callback scheduling fails',
                  })}
                </BodyTextBlock>
              </Group>
            </VerticalSpacer>
          </ModalContent>
        </ModalBody>
        <ModalFooter primaryActionProps={{
          children: intl.formatMessage({
            id: 'LRiZV7DQHg',
            defaultMessage: 'Close',
            description: 'Close button for callback error modal',
          }),
        }}
        />
      </form>
    </ModalBase>
  )
}
